import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            热度排行
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">爆料热度榜</h2>
          <p className="text-sm text-foreground-600 mt-2">实时更新的热门爆料排行，看看大家都在关注什么</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed truncate">{item.title}</p>
              </div>
              <div className="flex items-center gap-1 shrink-0">
                {item.hot && <i className="ri-fire-fill text-primary-500 text-sm"></i>}
                {item.hot && <span className="text-xs text-primary-500 font-medium whitespace-nowrap">热门</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}